<template>
  <RootComponent/>
</template>

<script>
import RootComponent from './components/RootComponent.vue'

export default {
  name: 'App',
  components: {
    RootComponent
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: 'Noto Sans', sans-serif;
}
#app { 
  height: 100%;
  width: 100%;
}
RootComponent {
  height: 100%;
  width: 100%;
}
.noto-sans-regular {
  font-family: "Noto Sans", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings:
    "wdth" 100;
}

.honk-regular {
  font-family: "Honk", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
  font-variation-settings:
    "MORF" 15,
    "SHLN" 50;
}

.honk-large {
  font-family: "Honk", serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
  font-variation-settings:
    "MORF" 15,
    "SHLN" 50;
  font-size: 2em;
}
</style>
